export interface Info {
  title: string
  items: string[]
}

const Info: Info[] = [
  {
    title: "General Information",
    items: [
      "Free worldwide shipping for orders placed on the Urban Armor Gear website.",
      "Orders are processed Monday to Friday. Orders placed during off-hours (such as weekends and major holidays) will be shipped the following business day.",
      "Back-ordered products will be shipped once stock becomes available, with the selected ship method.",
      "To accelerate delivery, orders may ship from our local or international fulfillment center.",
      "Orders with multiple products may be shipped separately if product is not immediately available.",
      "Pre-order items will ship with the requested shipping speed, as soon as the goods become available.",
    ],
  },
  {
    title: "Order Processing",
    items: [
      "After you place an order, you will receive an order confirmation email. Our warehouse team will then begin the process of packaging and shipping your order, this process can take between 24 to 72 hours. Once your order has shipped from our warehouse, a follow-up email will be sent that will include your tracking information.",
    ],
  },
  {
    title: "Domestic Orders",
    items: [
      "Orders shipped from our US warehouse will be shipped via USPS unless we are notified during the checkout process. US orders will ship to the following areas: Continental United States, Hawaii, Alaska, American Samoa, Guan, the Northern Mariana Islands, Puerto Rico, and the US Virgin Islands.",
    ],
  },
  {
    title: "Expedited Shipping",
    items: [
      "Expedited orders must be received by 11AM PST to have the order processed on the same day. An expedited order that is received after 11AM PST will be shipped the following business day.",
      "We do not ship expedited orders on weekends or major holidays. For example, if a Standard Overnight order is placed on a Friday at 1PM PST, it will ship the following Monday (the order was received past the 11AM PST cutoff to ship same day).",
      "If product is back-ordered or out of stock, once product is in stock, it will ship with the selected shipping method.",
      "Expedited shipping does apply to P.O. Boxes, APO's, or US Territories.",
    ],
  },
  {
    title: "International Shipping",
    items: [
      "Orders shipped from our Hong Kong warehouse will be shipped via Hong Kong Post. At this time we do not offer expedited shipping for international orders.",
    ],
  },
  {
    title: "Additional Information",
    items: [
      "Orders may be delayed due to having an invalid shipping address, custom clearance, natural disasters, major holidays, out of stock, etc.",
      "International orders may be subject to import and custom fees imposed by the destination country. Urban Armor Gear has no control over these fees and is not responsible. For more information, please follow-up with your local customs office.",
      "We do not ship to the following countries: North Korea, Congo, Ivory Coast, Liberia, Sierra Leone, Burma, Belarus, Iran, Iraq, Syria, Aland Islands, Angola, Bouvet Island, Curaçao, Guernsey, Heard Island and McDonald Islands, Holy See (Vatican City State), Isle Of Man, Jersey, Liechtenstein, Macao, Mayotte, Mozambique, Niue, Reunion, Saint Barthélemy, Saint Martin, Svalbard And Jan Mayen, Tokelau, Turks and Caicos Islands, Western Sahara.",
      "For any additional questions or concerns, please visit our Help Center",
    ],
  },
]

export default Info
